import { Box, styled } from "@mui/material";
import { Typography } from "@platform/design-system";
import React from "react";

import bannerBkg from "../assets/bannerBkg.svg";

type BannerProps = {
  companyName: string;
  brokerName: string;
};

const MAX_LEN_COMPANY_NAME = 100;
const MAX_LEN_BROKER_NAME = 120;

const Banner = ({
  companyName,
  brokerName,
}: BannerProps): React.JSX.Element => (
  <Box>
    <StyledBox>
      <EllipsisTypography
        maxLen={MAX_LEN_COMPANY_NAME}
        variant="display-small"
        color="inherit"
      >
        {companyName}
      </EllipsisTypography>
      <EllipsisTypography
        maxLen={MAX_LEN_BROKER_NAME}
        variant="body-medium"
        color="inherit"
      >
        Broker: {brokerName}
      </EllipsisTypography>
    </StyledBox>
  </Box>
);

const EllipsisTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "maxLen",
})<{ maxLen: number }>(({ maxLen }) => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: `${maxLen}ch`,
  display: "block",
}));

const StyledBox = styled(Box)(() => ({
  backgroundColor: "transparent",
  backgroundImage: `url(${bannerBkg})`,
  color: "white",
  backgroundSize: "cover",
  borderBottomRightRadius: "15% 100%",
  padding: "1rem 4.375rem",
}));

export default Banner;
